(function() {
  'use strict';

  function BlueprintMapsController(
    $rootScope, Profile, BlueprintMaps, BlueprintMapSearch, List, Security, $translate, Utils
  ) {
    var ctrl = this;
    Utils.setPageTitle('Blueprint maps');
    ctrl.options = {};
    ctrl.options.actionButtons = function(item) {
      return [
        {
          label: $translate.instant('Edit'),
          icon: 'icon-edit',
          route: (function() {
            return ['/blueprint-maps', item.doc._id, 'edit'];
          })(),
          showCondition: Security.hasPermission.bind(this, 'blueprints.edit'),
          klass: 'text-info'
        },
        {
          label: $translate.instant('Mapping'),
          icon: 'icon-edit',
          route: (function() {
            return ['/blueprint-maps', item.doc._id, 'mapping'];
          })(),
          showCondition: function() { return true; },
          klass: 'text-info'
        }
      ];
    };

    ctrl.searchModel = Profile.getListPreferences('blueprintMaps').current;

    ctrl.actions = [
      {
        label: $translate.instant('New blueprint map'),
        icon: 'icon-edit',
        route: ['/blueprint-maps/new'],
        showCondition: Security.hasPermission.bind(this, 'blueprints.edit'),
        klass: 'btn-success'
      }
    ];

    ctrl.list = new List({
      search: BlueprintMapSearch.search,
      model: ctrl.searchModel,
      idField: 'doc._id'
    });
    $rootScope.$broadcast('KZCurrentListChange',
      { list: 'blueprintMaps', search: ctrl.list.search }
    );

    BlueprintMaps.findAll({ cached: false })
      .then(function(items) {
        ctrl.list.doLoadItems(items);
      });
  }

  BlueprintMapsController.$inject = [
    '$rootScope',
    'ProfileService',
    'BlueprintMapsService',
    'BlueprintMapSearch',
    'ListFactory',
    'SecurityService',
    '$translate',
    'UtilsService'
  ];

  angular.module('component.blueprints')
    .controller('BlueprintMapsController', BlueprintMapsController);
})();
